export default __webpack_public_path__ + "fonts/bariol_bold-webfont.woff2";